import Image from 'next/image'

import { translationsEN, translationsTH } from './constants'
import { CustomModal } from '../CustomModal/CustomModal'

import styles from './maintenance.module.css'

type Props = {
  isOpen: boolean
  onClose: () => void
}

export const MaintenanceModal = ({ isOpen, onClose }: Props) => {
  return (
    <CustomModal
      isOpen={process.env.NEXT_PUBLIC_IS_UNDER_MAINTENANCE === 'true' && isOpen}
      onClose={onClose}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Image
          src="/images/logo.svg"
          alt="Header logo"
          width={200}
          height={200}
        />

        <h2 style={{ fontWeight: 'bold', fontSize: '1.5rem' }}>
          {translationsEN.title}
        </h2>

        <p style={{ color: '#555' }}>{translationsTH.title}</p>

        <p style={{ marginTop: '1rem', fontSize: '.95rem' }}>
          {translationsEN.message}
        </p>
        <p style={{ color: '#777', marginBottom: '1.5rem' }}>
          {translationsTH.message}
        </p>

        <p style={{ color: '#008cff', fontWeight: 'bold' }}>
          nDataThoth Limited
        </p>

        <button className={styles.button} onClick={onClose}>
          Close
        </button>
      </div>
    </CustomModal>
  )
}
